"use strict";

exports.__esModule = true;
exports.getSortQueryParams = exports.mapToAppSettings = exports.SORT_BY_LIKES = exports.SORT_BY_MOST_VIEWS = exports.SORT_BY_COMMENTS = exports.SORT_BY_OLDEST = exports.SORT_BY_NEWEST = exports.SORT_BY_LAST_ACTIVITY = exports.SORT_BY_BEST_MATCH = void 0;

var _mapToAppSettings, _mapSortToQueryParams;

var SORT_BY_BEST_MATCH = 'sortByBestMach';
exports.SORT_BY_BEST_MATCH = SORT_BY_BEST_MATCH;
var SORT_BY_LAST_ACTIVITY = 'sortByLastActivity';
exports.SORT_BY_LAST_ACTIVITY = SORT_BY_LAST_ACTIVITY;
var SORT_BY_NEWEST = 'sortByNewest';
exports.SORT_BY_NEWEST = SORT_BY_NEWEST;
var SORT_BY_OLDEST = 'sortByOldest';
exports.SORT_BY_OLDEST = SORT_BY_OLDEST;
var SORT_BY_COMMENTS = 'sortByMostComments';
exports.SORT_BY_COMMENTS = SORT_BY_COMMENTS;
var SORT_BY_MOST_VIEWS = 'sortByMostViews';
exports.SORT_BY_MOST_VIEWS = SORT_BY_MOST_VIEWS;
var SORT_BY_LIKES = 'sortByLikes';
exports.SORT_BY_LIKES = SORT_BY_LIKES;
var mapToAppSettings = (_mapToAppSettings = {}, _mapToAppSettings[SORT_BY_LAST_ACTIVITY] = '1', _mapToAppSettings[SORT_BY_NEWEST] = '2', _mapToAppSettings[SORT_BY_COMMENTS] = '3', _mapToAppSettings[SORT_BY_MOST_VIEWS] = '4', _mapToAppSettings[SORT_BY_LIKES] = '5', _mapToAppSettings);
exports.mapToAppSettings = mapToAppSettings;
var param = {
  BEST_MATCH: '',
  CREATED_DATE: 'createdDate',
  LAST_ACTIVITY_DATE: 'lastActivityDate',
  TOTAL_COMMENTS: 'totalComments',
  VIEW_COUNT: 'viewCount',
  LIKE_COUNT: 'likeCount',
  ORDER_ASC: 'asc',
  ORDER_DESC: 'desc'
};
var mapSortToQueryParams = (_mapSortToQueryParams = {}, _mapSortToQueryParams[SORT_BY_BEST_MATCH] = {
  sort: param.BEST_MATCH
}, _mapSortToQueryParams[SORT_BY_NEWEST] = {
  sort: param.CREATED_DATE,
  order: param.ORDER_DESC
}, _mapSortToQueryParams[SORT_BY_OLDEST] = {
  sort: param.CREATED_DATE,
  order: param.ORDER_ASC
}, _mapSortToQueryParams[SORT_BY_LAST_ACTIVITY] = {
  sort: param.LAST_ACTIVITY_DATE,
  order: param.ORDER_DESC
}, _mapSortToQueryParams[SORT_BY_COMMENTS] = {
  sort: param.TOTAL_COMMENTS
}, _mapSortToQueryParams[SORT_BY_MOST_VIEWS] = {
  sort: param.VIEW_COUNT
}, _mapSortToQueryParams[SORT_BY_LIKES] = {
  sort: param.LIKE_COUNT
}, _mapSortToQueryParams);

var getSortQueryParams = function getSortQueryParams(sort) {
  return mapSortToQueryParams[sort];
};

exports.getSortQueryParams = getSortQueryParams;